/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { AlbumListState } from './AlbumList/reducer';
import { GlobalState } from '../actions';

export const albumListState = (state: GlobalState): AlbumListState => state.playlistAdmin.albumList;
